export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/node/client/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/Branches',
    name: '/Branches',
    component: () => import('/home/node/client/src/pages/Branches.vue'),
    /* no children */
  },
  {
    path: '/Employes',
    name: '/Employes',
    component: () => import('/home/node/client/src/pages/Employes.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/Login',
    name: '/Login',
    component: () => import('/home/node/client/src/pages/Login.vue'),
    /* no children */
  },
  {
    path: '/OKR',
    name: '/OKR',
    component: () => import('/home/node/client/src/pages/OKR.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/RapportFacturation',
    name: '/RapportFacturation',
    component: () => import('/home/node/client/src/pages/RapportFacturation.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/RapportFeuilleTemps',
    name: '/RapportFeuilleTemps',
    component: () => import('/home/node/client/src/pages/RapportFeuilleTemps.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/RapportJournalier',
    name: '/RapportJournalier',
    component: () => import('/home/node/client/src/pages/RapportJournalier.vue'),
    /* no children */
  },
  {
    path: '/RapportKanban',
    name: '/RapportKanban',
    component: () => import('/home/node/client/src/pages/RapportKanban.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/RapportPlanification',
    name: '/RapportPlanification',
    component: () => import('/home/node/client/src/pages/RapportPlanification.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/RapportProduction',
    name: '/RapportProduction',
    component: () => import('/home/node/client/src/pages/RapportProduction.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/SyncAbsences',
    name: '/SyncAbsences',
    component: () => import('/home/node/client/src/pages/SyncAbsences.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "roles": [
        "admin",
        "manager"
      ]
    }
  },
  {
    path: '/TableauBord',
    name: '/TableauBord',
    component: () => import('/home/node/client/src/pages/TableauBord.vue'),
    /* no children */
  },
  {
    path: '/tasks',
    name: '/tasks',
    component: () => import('/home/node/client/src/pages/tasks.vue'),
    /* no children */
  },
  {
    path: '/ZoomEmploye',
    name: '/ZoomEmploye',
    component: () => import('/home/node/client/src/pages/ZoomEmploye.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

